/** Role codes hidden from workflow / checklist pickers (same as Global Settings). */
export const EXCLUDED_POLICY_ROLE_CODES = new Set(["ADMIN", "SUPER_ADMIN"]);

export function normalizeRoleCodeForMatch(code) {
  let normalized = String(code || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/\//g, "_");
  // Legacy leave/policy values ↔ seeded User Roles codes (MANAGER, EMPLOYEE)
  if (
    normalized === "reporting_manager" ||
    normalized === "reportingmanager" ||
    normalized === "report_manager"
  ) {
    normalized = "manager";
  }
  if (normalized === "employee_self" || normalized === "employee_/_self") {
    normalized = "employee";
  }
  return normalized;
}

/**
 * Maps `/global-settings/roles` rows to `{ value, label, type, id, isSystem }`.
 * Includes custom roles and system roles (System Role Badges in RoleListView).
 */
export function buildRoleSelectOptions(roles = [], { activeOnly = true } = {}) {
  return (Array.isArray(roles) ? roles : [])
    .filter((role) => role && !EXCLUDED_POLICY_ROLE_CODES.has(String(role.code || "").toUpperCase()))
    .filter((role) => !activeOnly || role.active !== false)
    .map((role) => ({
      value: String(role.code || "").trim(),
      label: role.name || role.code,
      type: role.type,
      id: role.id,
      isSystem: role.type === "system",
    }))
    .filter((role) => role.value)
    .sort((a, b) => {
      if (a.isSystem !== b.isSystem) return a.isSystem ? -1 : 1;
      return a.label.localeCompare(b.label, undefined, { sensitivity: "base" });
    });
}

export function getRoleLabel(roleOptions, roleValue) {
  if (!roleValue) return "—";
  const normalized = normalizeRoleCodeForMatch(roleValue);
  const found = roleOptions.find((role) => normalizeRoleCodeForMatch(role.value) === normalized);
  return found?.label || roleValue;
}

/** Align stored policy values (legacy lowercase) with option values from the API. */
export function resolveRoleSelectValue(roleOptions, storedValue) {
  if (!storedValue) return roleOptions[0]?.value || "";
  const normalized = normalizeRoleCodeForMatch(storedValue);
  const found = roleOptions.find((role) => normalizeRoleCodeForMatch(role.value) === normalized);
  return found?.value ?? storedValue;
}

export function splitRoleSelectOptions(roleOptions = []) {
  const systemRoleOptions = roleOptions.filter((role) => role.isSystem);
  const customRoleOptions = roleOptions.filter((role) => !role.isSystem);
  return { systemRoleOptions, customRoleOptions };
}
